function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Container, Row, Col, Nav, NavItem, NavLink, Card, CardBody, CardHeader } from 'reactstrap';
import { createHashHistory } from 'history';
import { Prompt } from 'react-router-dom';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import FormModal from '../forms/formModal';
import SectionPanel from '../common/containers/sectionPanel';
import routeHelper from '../common/classes/routeHelper';
import RejectionNoteModal from './rejectionNoteModal';
import ReportIssueSummary from './reportIssueSummary';
// import logger from '../../utils/logger';
import Loader from '../common/loader';
import EditorComponent from '../editor/editorComponent';
const hashHistory = createHashHistory();
export const getLatestStatus = report => {
  if (!report || !report.active || !report.active.content) {
    return null;
  }
  const {
    active: {
      content: {
        statusHistory
      }
    }
  } = report;
  if (!statusHistory) {
    return null;
  }
  let newestStatus = null;
  Object.keys(statusHistory).forEach(key => {
    const status = statusHistory[key];
    /* eslint-disable no-underscore-dangle */
    if (!newestStatus || new Date(status._created) > new Date(newestStatus._created)) {
      newestStatus = status;
    }
    /* eslint-enable no-underscore-dangle */
  });
  return newestStatus;
};
class ReportEditor extends Component {
  constructor(props) {
    if (!props.match.params || !props.match.params.id) {
      throw new Error('props.match.params.id is required');
    }
    super(props);

    /* eslint-disable-next-line react/no-unused-class-component-methods */
    this.format = {};
    this.state = {
      loaded: true,
      // track initial loading to avoid Loader usage on saves
      sectionIndex: null,
      rejectionNoteModal: {
        active: false,
        note: null,
        open: false,
        acknowledged: false
      }
    };
    this.getSectionIndex = this.getSectionIndex.bind(this);
    this.getSections = this.getSections.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSelectSection = this.handleSelectSection.bind(this);
    this.toggleRejectionModal = this.toggleRejectionModal.bind(this);
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      match: {
        params: {
          id
        }
      },
      report: {
        active: {
          id: activeID
        },
        loading,
        newReportID
      }
    } = nextProps;
    let newState = null;
    if (prevState.loaded && loading && id !== activeID) {
      // display the Loader
      newState = _objectSpread(_objectSpread({}, newState), {}, {
        loaded: false
      });
    } else if (!prevState.loaded && !loading) {
      // hide the Loader
      newState = _objectSpread(_objectSpread({}, newState), {}, {
        loaded: true
      });
    }

    // If new report id is set, ignore checking for rejections
    if (!newReportID) {
      const reportStatus = getLatestStatus(nextProps.report);
      if (reportStatus && reportStatus.identifier && reportStatus.identifier === 'rejected' && reportStatus.note !== '' && !prevState.rejectionNoteModal.acknowledged) {
        newState = _objectSpread(_objectSpread({}, newState), {}, {
          rejectionNoteModal: {
            active: true,
            note: reportStatus.note,
            open: true
          }
        });
      }
    }
    return newState;
  }
  componentDidMount() {
    const {
      match: {
        params: {
          id
        }
      },
      reportActions
    } = this.props;
    reportActions.serverShow(id);
  }
  componentWillUnmount() {
    const {
      reportActions
    } = this.props;
    reportActions.showCancel();
  }
  getSectionFormat() {
    const sectionKey = this.getSectionIndex();
    const sections = this.getSections();
    const section = sections.find(currentSection => currentSection.label === sectionKey);
    return section ? section.format : undefined;
  }
  getSectionIndex() {
    const {
      match: {
        params
      }
    } = this.props;
    const {
      sectionIndex
    } = this.state;

    // return the first section.
    const sections = this.getSections();
    if (sectionIndex) {
      if (sections.some(next => next.label === sectionIndex)) {
        return sectionIndex;
      }
    }
    if (params.section) {
      let sectionToLoad;
      sections.forEach(next => {
        if (kebabCase(next.label) === kebabCase(params.section)) {
          sectionToLoad = next.label;
        }
      });
      if (sectionToLoad) {
        return sectionToLoad;
      }
    }
    if (sections && sections.length > 0) {
      return sections[0].label;
    }

    // what should we return as default?
    return 'General';
  }
  getSections() {
    const {
      report: {
        active: {
          format = {}
        }
      }
    } = this.props;
    if (format && format.children) {
      return format.children.map(child => ({
        label: child.label,
        format: child
      }));
    }
    return [];
  }
  redirectUser() {
    const {
      location: {
        pathname
      },
      notificationActions
    } = this.props;
    notificationActions.error({
      message: `You are not authorized to access ${this.getPathname ? pathname : 'this resource.'}`
    });
    hashHistory.replace('/accessDenied');
  }
  handleBack() {
    const {
      report: {
        active: {
          id
        }
      }
    } = this.props;
    if (id === undefined) {
      return;
    }
    routeHelper.updateURL(`/reports/${id}`);
  }
  async handleChange({
    path,
    value,
    changeModifiers = {}
  }) {
    const {
      reportActions,
      match: {
        params: {
          id
        }
      }
    } = this.props;
    const contentPath = `content/${path}`;
    // create a change action with the new info.
    // need to prepend the content object to this keypath
    return reportActions.change(id, contentPath, value, changeModifiers);
  }
  async handleSave() {
    const {
      reportActions: {
        serverSave
      },
      report: {
        active
      }
    } = this.props;
    const version = active && active.content && active.content.version || undefined;
    // used in the routeHeloper transitionAsync method as well as section panel onSave
    serverSave(version);
  }
  handleSelectSection(sectionkey) {
    this.setState({
      sectionIndex: sectionkey
    });
  }
  toggleRejectionModal() {
    const {
      rejectionNoteModal: {
        open
      }
    } = this.state;
    this.setState({
      rejectionNoteModal: {
        open: !open,
        acknowledged: true
      }
    });
  }
  render() {
    const {
      report: {
        pendingChanges,
        loading,
        active
      },
      canEdit,
      reportActions: {
        operationComplete,
        operationPending
      }
    } = this.props;
    const {
      loaded,
      rejectionNoteModal
    } = this.state;

    // Check if user authenticated first
    if (active && active.content && !canEdit) {
      this.redirectUser();
    }
    const isReportLoaded = active && active.id;
    const content = active && active.content ? active.content : null;
    const {
      content: {
        reportType: {
          name: reportTypeName
        } = {}
      } = {},
      reportNumber = {}
    } = active;
    const sectionIndex = this.getSectionIndex();
    const sectionFormat = this.getSectionFormat();
    const sections = this.getSections();
    let hasSection = false;
    if (sectionFormat && sectionFormat.children) {
      hasSection = true;
    }
    let sectionKeyPath = '/';
    if (sectionFormat && sectionFormat.contentPath) {
      sectionKeyPath = sectionFormat.contentPath.substring(0, 1) === '/' ? sectionFormat.contentPath : `/${sectionFormat.contentPath}`; // prepend path with '/' if contentPath exists
    }
    let reportTitle = '';
    if (content && reportTypeName && reportNumber) {
      reportTitle = `${reportTypeName} ${reportNumber}`;
    }
    return /*#__PURE__*/React.createElement(Loader, {
      top: "50%",
      loaded: loaded
    }, /*#__PURE__*/React.createElement(Container, {
      className: "ReportEditor"
    }, /*#__PURE__*/React.createElement(Prompt, {
      when: pendingChanges,
      message: location => routeHelper.transitionAsync(this, 'report', location)
    }), rejectionNoteModal.active && /*#__PURE__*/React.createElement(RejectionNoteModal, {
      isOpen: rejectionNoteModal.open,
      onHide: this.toggleRejectionModal,
      rejectionNote: rejectionNoteModal.note
    }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
      className: "card-heading"
    }, /*#__PURE__*/React.createElement("h3", null, "Report Sections")), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Nav, {
      vertical: true,
      pills: true
    }, sections.map(section => /*#__PURE__*/React.createElement(NavItem, {
      style: {
        maxWidth: '100%'
      },
      className: `t-re-nav-section-${kebabCase(section.label)} report-nav-item`,
      active: sectionIndex === section.label,
      key: `NAV_${section.label.replace(/[\s-]/g, '')}`
    }, /*#__PURE__*/React.createElement(NavLink, {
      onClick: () => this.handleSelectSection(section.label)
    }, section.label)))))), /*#__PURE__*/React.createElement(ReportIssueSummary, {
      noURL: true,
      report: active
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 9
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SectionPanel, {
      isPending: pendingChanges,
      isSaveDisabled: loading,
      onBack: this.handleBack,
      backButtonTitle: isReportLoaded ? 'View Report PDF' : 'Loading...',
      onSave: this.handleSave,
      name: reportTitle,
      showTagButton: true
    }, hasSection ? /*#__PURE__*/React.createElement(EditorComponent, {
      path: sectionKeyPath,
      format: sectionFormat,
      onChange: this.handleChange,
      reduxEntity: "report",
      operationComplete: operationComplete,
      operationPending: operationPending
    }) : /*#__PURE__*/React.createElement("div", {
      style: {
        minHeight: '300px'
      }
    }, active && !loading && /*#__PURE__*/React.createElement("p", {
      "data-testid": "t-re-no-section"
    }, "This section", /*#__PURE__*/React.createElement("strong", null, "\xA0", sectionFormat && sectionFormat.label ? sectionFormat.label : '', "\xA0"), "is not defined in the editor."))))))), /*#__PURE__*/React.createElement(FormModal, null));
  }
}
ReportEditor.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
      section: PropTypes.string
    }).isRequired
  }).isRequired,
  report: PropTypes.shape({
    activeCache: PropTypes.shape({
      staticContent: PropTypes.shape({})
    }),
    active: PropTypes.shape({
      content: PropTypes.shape({
        reportType: PropTypes.shape({
          name: PropTypes.string
        }),
        version: PropTypes.string
      }),
      format: PropTypes.shape({}),
      ReportType: PropTypes.shape({}),
      reportNumber: PropTypes.number,
      id: PropTypes.string
    }),
    error: PropTypes.shape({
      response: PropTypes.shape({
        status: PropTypes.number
      })
    }),
    loading: PropTypes.bool,
    pendingChanges: PropTypes.bool,
    newReportID: PropTypes.string
  }).isRequired,
  user: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }).isRequired,
  reportActions: PropTypes.shape({
    change: PropTypes.func,
    operationPending: PropTypes.func,
    operationComplete: PropTypes.func,
    showCancel: PropTypes.func,
    serverSave: PropTypes.func,
    serverShow: PropTypes.func,
    showSuccess: PropTypes.func
  }).isRequired,
  notificationActions: PropTypes.shape({
    error: PropTypes.func,
    info: PropTypes.func
  }).isRequired
};
export { ReportEditor as TestReportEditor };

// This entity is wrapped by "reportEditorContainer.js" which handles selectors etc.
export default ReportEditor;